<template>
  <div>
    <div v-for="(msg, index) in msgs" :key="index">
      <div
        v-if="openMessage || index === 0"
        class="min-h-60px flex items-center bg-light-pink text-deep-brown"
        :class="{
          'px-8px': mobileStyle,
          'px-64px': !mobileStyle,
          'border-t border-deep-brown border-opacity-10': index !== 0,
        }"
      >
        <div
          class="my-14px flex flex-grow-1 items-center gap-4px"
          :class="{
            'justify-center': !mobileStyle,
          }"
        >
          <i class="icon-tag text-24px" />
          <div
            v-clean-html="msg"
            class="content-11-h16-r"
            :class="{ 'line-clamp-2': !openMessage }"
          />
        </div>
        <p class="ml-4px w-24px flex-shrink-0">
          <i
            v-if="index === 0"
            class="float-right cursor-pointer text-24px"
            :class="{
              'icon-chevron-down': !openMessage,
              'icon-chevron-up': openMessage,
            }"
            @click="toggleOpenMessage"
          />
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { useLayoutStore } from '@/store/layoutStore'
import { useNewProductStore } from '@/store/newProductStore'
import { getPromoteMessagesByProduct } from '@/utils/promoteMessage'

const layoutStore = useLayoutStore()
const productStore = useNewProductStore()

let intervalNumber: null | number = null
function setCarousel(): void {
  if (intervalNumber !== null) {
    window.clearInterval(intervalNumber)
  }
  if (msgs.value.length <= 1) {
    return
  }
  intervalNumber = window.setInterval(carousel, 3000)
}

function toggleOpenMessage(): void {
  openMessage.value = !openMessage.value
  if (!openMessage.value) {
    setCarousel()
  } else if (intervalNumber !== null) {
    window.clearInterval(intervalNumber)
  }
}

watch(() => productStore.$state.productState?.selectedProduct, setMessages, { immediate: true })

async function setMessages(): Promise<void> {
  const productHandle = productStore.$state.productState?.selectedProduct?.product.handle
  if (productHandle === undefined) {
    return
  }
  const messages = await getPromoteMessagesByProduct(productHandle)
  // strapi 帶回來的 a 標籤 target 是空字串，所以需要把它變成 _blank 新開分頁
  msgs.value = messages.map((item) => item.replace(/<a target=""/g, '<a target="_blank"'))
  setCarousel()
}

function carousel(): void {
  msgs.value.push(...msgs.value.splice(0, 1))
}

const msgs = ref<string[]>([])
const openMessage = ref(false)
const mobileStyle = computed(() => layoutStore.isMobile || !layoutStore.isRwdPage)
</script>
